export const TAB_NAME_MAP: Record<number, string> = {
  0: 'Overview',
  1: 'Personalized Engagement',
  2: 'HCP Engagement',
  3: 'Scientific Information',
  4: 'Partner Score',
  5: 'Segmentation',
  6: 'HCP Insights',
};

export class TabStateManager {
  private activeTab = 'Overview';

  setActiveTab(tabIndex: number | string): void {
    if (typeof tabIndex === 'number') {
      this.activeTab = TAB_NAME_MAP[tabIndex] || 'Overview';
    } else {
      this.activeTab = tabIndex;
    }
  }

  getActiveTab(): string {
    return this.activeTab;
  }
}
